module.exports = __webpack_public_path__ + "static/media/segway-ride.9197f1f2.jpg";